import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuth, AuthProvider } from "./context/AuthContext";

import SingleListing from "./pages/SingleListing";
import BatchListingManager from "./pages/BatchListingManager";
import LandingPage from "./pages/LandingPage";
import AuthBar from "./components/AuthBar/AuthBar";
import { getApiUrl } from "./lib/api";

import { DndContext, closestCenter } from "@dnd-kit/core";
import axios from "axios";

function AppContent() {
  const { user, checkingAuth, setUser } = useAuth();

  console.log("Auth status →", { checkingAuth, user });

  // 🔄 JWT silent refresh logic
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      axios
        .post(getApiUrl("/api/auth/refresh"))
        .then(() => console.log("🔄 JWT refreshed"))
        .catch((err) => console.warn("❌ JWT refresh failed", err));
    }, 60 * 60 * 1000); // every 60 min

    return () => clearInterval(interval);
  }, [user]);

  if (checkingAuth) {
    return (
      <div className="p-6 text-center text-white">
        Checking authentication...
      </div>
    );
  }

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </Router>
    );
  }

  const handleDragEnd = (event) => {
    // We'll define this in BatchListingManager instead — just passing through here for structure.
  };

  return (
    <Router>
      <div className="min-h-screen bg-black text-white">
        <AuthBar user={user} setUser={setUser} />
        <div className="max-w-4xl mx-auto p-6">
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <Routes>
              <Route path="/" element={<SingleListing user={user} />} />
              <Route
                path="/batch"
                element={<BatchListingManager user={user} />}
              />
            </Routes>
          </DndContext>
        </div>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
